export const FormMode = {
  Create: "create", // For CRUD (Create / POST)
  Edit: "edit", // For CRUD (Edit / PUT)
  Delete: "delete", // For CRUD (Delete / DELETE)
  Submit: "submit", // For standard form submitting not tied to an entity, non-CRUD (POST)
};
